import song1 from "./assests/songs/Besharam Rang - Pathaan.mp3";
import song2 from "./assests/songs/Enrique_Iglesias_hero.mp3";
import song3 from "./assests/songs/James_Blunt_Youre_Beautiful.mp3";

export const songs = [
  {
    name: "Besharam Rang",
    author: "Pathaan",
    path: song1,
  },
  {
    name: "I Can Be Your Hero Baby",
    author: "Enrique Iglesias",
    path: song2,
  },
  {
    name: "You’re Beautiful ",
    author: "James Blunt",
    path: song3,
  },
];
